<ion-toolbar mode="ios" class="toolbar-wrapper">
  <div class="toolbar-wrapper__inner">
    <div class="toolbar-search-fields">
      <ion-searchbar autocomplete="on" autocorrect="on" inputmode="search"
        [ngClass]="{ 'is-loading': isFieldLoading('multiFieldSearch') }"
        [placeholder]="multiFieldSearchPlaceholderKey | translate"
        [disabled]="showSkeleton"
        [debounce]="0"
        [value]="currentMultiFieldSearchValue"
        (ionFocus)="onFocus('multiFieldSearch')"
        (ionInput)="onInputChange($event, 'multiFieldSearch')"
        (ionClear)="onInputChange($event, 'multiFieldSearch')"
        (ionBlur)="onBlur()">
        @if (isFieldLoading('multiFieldSearch')) {
          <ion-spinner color="medium" class="proto-spinner"></ion-spinner>
        }
      </ion-searchbar>
      @if (showLocationSearch) {
        <ion-searchbar autocomplete="on" autocorrect="on" inputmode="search"
          search-icon="location-outline"
          [ngClass]="{ 'is-loading': isFieldLoading('secondarySearch') }"
          [placeholder]="secondarySearchPlaceholderKey | translate"
          [disabled]="showSkeleton"
          [debounce]="0"
          [value]="currentSecondarySearchValue"
          (ionFocus)="onFocus('secondarySearch')"
          (ionInput)="onInputChange($event, 'secondarySearch')"
          (ionClear)="onInputChange($event, 'secondarySearch')"
          (ionBlur)="onBlur()">
          @if (isFieldLoading('secondarySearch')) {
            <ion-spinner color="medium" class="proto-spinner"></ion-spinner>
          }
        </ion-searchbar>
      }
    </div>

    @if (showFilter) {
      <ion-button class="search-filter-button" color="primary"
        fill="clear"
        [ngClass]="{ 'is-active': filterIsActive }"
        [disabled]="showSkeleton || isLoading"
        (click)="filterClicked.emit()">
        <span class="search-filter-button__label is-hidden-until-bp-xl">{{ 'BUTTON.FILTER' | translate }}</span>
        @if (showSkeleton || (isLoading && activeSearchField === 'unset')) {
          <ion-spinner class="proto-spinner"></ion-spinner>
        } @else {
          <ion-icon name="filter-outline" class="search-filter-button__icon"></ion-icon>
        }
      </ion-button>
    }

    <ng-content select=".search-filter-replacement"></ng-content>

    <ng-content select=".search-submit-button"></ng-content>
  </div>

  <ng-content select=".toolbar-meta-wrapper"></ng-content>
</ion-toolbar>
